export default {
  userEmail: state => state.user.email,
  currentUser: state => state.currentUser,
  newUser: state => state.newuser,
  userList: state => state.users.map(user => {
    return {
      ...user,
      name: user.firstName + " " + user.lastName
    }
  }),
  userMasterList: state => state.users.filter(u => u.role == "master"),

  headerColor: state => state.configuration.headerColor,
  menuColor: state => state.configuration.menuColor,
  logo: state => state.configuration.logo,

  edificios: state => state.buildings.buildingsList||[],
  listaEdificios: state =>{
    return state.buildings.buildingsList.map(b => {
      return {name: b.name, id: b.id  }
    })
  },
  puntosControl: state => state.buildings.controlPointList,
  listaTareas: state => state.currentCP.tasks,
  newControlPoint: state => state.newControlPoint,
  cp_id: state => state.cp_id,
  currentCP: state => state.currentCP,
  currentlinkedbuildings: state => state.currentCP.linkedbuildings,

  modalEdificio: state => state.modalEdificio,
  modalDelete: state => state.modalDelete,
  modalTareas: state => state.modalTareas,
  showSidebar: state => state.showSidebar,
  imageTemp: state => state.imageTemp,
  imagePrew: state => state.imageTemp.preview,
  imageFile: state => state.imageTemp.file,
  company: state => state.company,
  companyID: state => state.company.id || JSON.parse(window.localStorage.getItem("companyID")),
  listBuild: state => state.localListBuild,

  company_id: state => state.companyId || JSON.parse(window.localStorage.getItem("companyID")),
  alternativas: state => (id) => {
    return state.currentCP.tasks.find(task => task.id == id).alternatives
  },
  taskById: state => (id) => {
    return state.currentCP.tasks.find(task => task.id == id)
  },
  taskByIndex: state => (index) => state.buildings.taskList[index],
  dashBuildings: state => state.dashBuildings,
  cpByIdBuild: state => (id) => {
    if(id){
      var cp = state.buildings.buildingsList.find(b => b.id === id).checkpoints
      return state.buildings.controlPointList.filter(c => cp.includes(c.id))
    } else {
      return state.buildings.controlPointList
    }
  },
  // getDashInfoWell: state => {
  //   return (Number(state.dashinfo.generalstatus.well)/(Number(state.dashinfo.generalstatus.well) + Number(state.dashinfo.generalstatus.bad)))*100
  // },
  // getDashInfoLeft: state => {
  //   return (Number(state.dashinfo.generalstatus.left)/(Number(state.dashinfo.generalstatus.left) + Number(state.dashinfo.generalstatus.bad) + Number(state.dashinfo.generalstatus.well)))*100},
  // getstatistics: state => state.dashinfo.statistics,
  getDashInfo: state => state.dashinfo,
  getBuildById: state => (id) => {
    var c =state.buildings.buildingsList.filter(b => b.id === id)
    return c[0]
  },
  getCPById: state => (id) => {
    var c =state.buildings.controlPointList.filter(b => b.id === id)
    return c[0]
  },
  getTaskById: state => (id) => {
    var c = state.buildings.taskList.filter(t => t.id === id)
    
    return c[0]
  },
  getReporteById: state => (id) => {
    var r = state.dashinfo.statistics.filter(re => re.id === id)
    return r[0]
  },
  getReport: state => state.reportInfo,
  getUserById: state => (id) => {
    var user = state.users.filter(u => u.id == id)
    return user[0]
  },
  getColorChildren: state => (str) => {
    switch(str){
      case 'dashboard': return state.colorDash; break;
      case 'edificios': return state.colorEdificios; break;
      case 'diseno': return state.colorDiseño; break;
      case 'listuser': return state.colorUsers; break;
      case 'statisticsReporters': return state.colorStRep; break;
      case 'statistics': return state.colorStat; break;
      case 'statisticCheckpointBuildings': return state.colorStCheckpoint; break;
    }
  },
  edificiosById: state => (id) => {
    if(id){
      if(id==="Todos-Edificios"){
        return state.buildings.buildingsList
      }else{
        return state.buildings.buildingsList.find(b => b.id === id)
      }
    }
  },
  role: state => state.isMaster,
  roleEdit: state => state.canEdit || state.isMaster,
  buildingsByCP: state => {
    if(state.currentCPStat){
      return state.currentCPStat.buildings.map(b => {
        let obj = {
          id: b.id,
          name: b.name
        }
        return obj
      })
    }
  },
  reportByCP: state => {
    if(state.currentCPStat) {
      return state.currentCPStat.listrep.map(r => {
        return r.report
      })
    }
  },
  reportByBuild: state => {
    if(state.currentCPStat) {
      return state.currentCPStat.listrep
    }
  },
  getUserName: state => (id) =>{
    let user = state.users.filter(u => u.id == id)[0]
    if(user.lastName){
      return `${user.firstName} ${user.lastName}`
    }else{
      return `${user.firstName}`
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/getters/index.js